module.exports = __webpack_public_path__ + "img/11 (1).ee705d35.jpg";